import { DirectDataInputConstant } from "presentation/constant/DirectDataInput/DirectDataInputConstant";
import { directDateInputStatusDropdownOption, masterTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useDirectDataInputVM } from "presentation/hook/DirectDataInput/useDirectDataInputVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDirectDataInputTracked } from "presentation/store/DirectDataInput/DirectDataInputProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const DirectDataInputEditPanel = () => {
    const SCREEN_CONSTANT = DirectDataInputConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [directDataInputState] = useDirectDataInputTracked();
    const directDataInputVM = useDirectDataInputVM();
    const { currentRow, searchCriteria, currentEditRow, isAdd, isEdit, masterState } = directDataInputState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const currentData = (isEdit || isAdd) ? currentEditRow : currentRow;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    const handleSave = useCallback(async () => {
        // if (!currentEditRow.masterType) {
        //     messageBarVM.showError("Master Type is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.opsDatetime) {
        //     messageBarVM.showError("Ops Date is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.forwarderCode) {
        //     messageBarVM.showError("Forwarder/Shipper/Consignee is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.truckerName) {
        //     messageBarVM.showError("Trucker Name is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.vehicleNo) {
        //     messageBarVM.showError("Vehicle No is mandatory.");
        //     return;
        // }
        // if ((operatingUnit === 'SAPT' || operatingUnit === 'KICT') && !currentEditRow.operatingTml) {
        //     messageBarVM.showError("Operating Tml is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        directDataInputVM.onSaveClicked();
        await directDataInputVM.onSave(currentEditRow, operatingUnit).then(data => {
            if (data && data.success) {
                directDataInputVM.onSearch(searchCriteria).then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            } else {
                setIsLoading(false)
                messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, directDataInputVM, messageBarVM, operatingUnit, searchCriteria]);

    const handClose = useCallback(() => {
        directDataInputVM.onCloseEidtPanel();
    }, [directDataInputVM]);


    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        directDataInputVM.onFieldChange(fieldName, fieldValue);
    }, [directDataInputVM]);

    const memoMasterType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentData?.masterType || ''}
                fieldValue={currentData?.masterType}
                fieldLabel={SCREEN_CONSTANT.MASTER_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'masterType'}
                maxLength={60}
                sort={false}
                options={masterTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentData?.masterType, SCREEN_CONSTANT.MASTER_TYPE, isSaveClicked, directDataInputVM])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentData?.forwarderCode || ''}
                fieldValue={currentData?.forwarderCode}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_SHIPPER_CONSIGNEE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCode'}
                maxLength={60}
                sort={false}
                options={directDataInputState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentData?.forwarderCode, SCREEN_CONSTANT.FORWARDER_SHIPPER_CONSIGNEE, isSaveClicked, directDataInputState.dynamicOptions.forwarderCodeDropdownOptions, directDataInputVM])

    const memoDamageType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!((isAdd || isEdit) && currentData.masterType === 'FINE')}
                isShowOptional={true}
                readOnlyValue={currentData?.damageType || ''}
                fieldValue={currentData?.damageType}
                fieldLabel={SCREEN_CONSTANT.DAMAGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'damageType'}
                maxLength={60}
                sort={false}
                options={directDataInputState.dynamicOptions.damageTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentData.masterType, currentData?.damageType, SCREEN_CONSTANT.DAMAGE_TYPE, isSaveClicked, directDataInputState.dynamicOptions.damageTypeDropdownOptions, directDataInputVM])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentData?.operatingTml || ''}
                fieldValue={currentData?.operatingTml}
                fieldLabel={SCREEN_CONSTANT.OPERATING_TML}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                sort={false}
                options={directDataInputState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, currentData?.operatingTml, SCREEN_CONSTANT.OPERATING_TML, isSaveClicked, directDataInputState.dynamicOptions.operatingTmlDropdownOptions, directDataInputVM])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentData?.status || ''}
                fieldValue={currentData?.status}
                fieldLabel={SCREEN_CONSTANT.STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'status'}
                maxLength={60}
                sort={false}
                options={directDateInputStatusDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, currentData?.status, SCREEN_CONSTANT.STATUS, isSaveClicked, directDataInputVM])

    const memoRemark = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "630px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!((isAdd || isEdit) && currentData.masterType === 'FINE')}
                isShowOptional={true}
                readOnlyValue={currentData.remark ?? ""}
                fieldValue={currentData?.remark ?? []}
                fieldLabel={SCREEN_CONSTANT.REMARK}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'remark'}
                maxLength={100}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REMARK, allFormState, currentData.masterType, currentData.remark, directDataInputVM, isAdd, isEdit, isSaveClicked])

    const memoTruckerName = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentData.truckerName ?? ""}
                fieldValue={currentData?.truckerName ?? []}
                fieldLabel={SCREEN_CONSTANT.TRUCKER_NAME}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'truckerName'}
                maxLength={30}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TRUCKER_NAME, allFormState, currentData.truckerName, directDataInputVM, isAdd, isEdit, isSaveClicked])

    const memoCnicNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentData.cnicNo ?? ""}
                fieldValue={currentData?.cnicNo ?? []}
                fieldLabel={SCREEN_CONSTANT.CNIC_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'cnicNo'}
                maxLength={15}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CNIC_NO, allFormState, currentData.cnicNo, directDataInputVM, isAdd, isEdit, isSaveClicked])

    const memoVehicleNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={currentData.vehicleNo ?? ""}
                fieldValue={currentData?.vehicleNo ?? []}
                fieldLabel={SCREEN_CONSTANT.VEHICLE_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vehicleNo'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.VEHICLE_NO, allFormState, currentData.vehicleNo, directDataInputVM, isAdd, isEdit, isSaveClicked])

    const memoNature = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!((isAdd || isEdit) && currentData.masterType === 'FINE')}
                isShowOptional={true}
                readOnlyValue={currentData.nature ?? ""}
                fieldValue={currentData?.nature ?? []}
                fieldLabel={SCREEN_CONSTANT.NATURE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'nature'}
                maxLength={20}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    directDataInputVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.NATURE, allFormState, currentData.masterType, currentData.nature, directDataInputVM, isAdd, isEdit, isSaveClicked])

    const memoAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.AMOUNT}
                optional={true}
                maxLength={10}
                fieldName={"amount"}
                value={currentData.amount ?? ''}
                errorMessage={allFormState ? allFormState["amount"] : ""}
                disabled={!(isAdd || isEdit)}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.AMOUNT, allFormState, currentData.amount, isAdd, isEdit, onNumberFieldChange])

    const memoOpsDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={!(isAdd || isEdit)}
                label={SCREEN_CONSTANT.OPS_DATE}
                width="300px"
                optional={false}
                date={currentData?.opsDatetime}
                fieldName="opsDatetime"
                errorMessage={allFormState ? allFormState["opsDatetime"] : ""}
                onDateChange={directDataInputVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.OPS_DATE, allFormState, currentData?.opsDatetime, directDataInputVM.onFieldChange, isAdd, isEdit])

    const handleEdit = useCallback(() => {
        directDataInputVM.onEditClick();
    }, [directDataInputVM]);

    const handleReset = useCallback(() => {
        directDataInputVM.onResetClick(isAdd);
    }, [directDataInputVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: SCREEN_CONSTANT.CATEGORY },
                    { title: SCREEN_CONSTANT.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {anaInfoState.allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Direct Data Input"}
                                    {isEdit && "Edit Direct Data Input"}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoStatus}
                            {memoMasterType}
                            {memoOpsDate}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoForwarderCode}
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoOperatingTml}
                            {memoAmount}
                            {(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') && memoDamageType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoTruckerName}
                            {memoCnicNo}
                            {memoVehicleNo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoDamageType}
                            {memoNature}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoRemark}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default DirectDataInputEditPanel;
